"use client";

import { useEffect } from "react";
import { recordRecentlyViewed } from "@/lib/hooks/useRecentlyViewed";

/**
 * Records this product as viewed in `localStorage`, independently of
 * Depict's own `recently_viewed` tracking (see `DepictView`). Depict's
 * pipeline takes several minutes to index a page view, so `CartRecentlyViewed`
 * falls back to this locally-tracked list when Depict hasn't caught up yet
 * (or the visitor has no Depict session at all — no cart token, ad blocker,
 * etc).
 *
 * Takes the base Centra product id (`ProductDetails["id"]`), not Depict's
 * variant-level id — the fallback rehydrates full product cards via
 * `products.exploration`, which fetches by that same base id.
 */
export const RecentlyViewedTracker = ({ productId }: { productId: string | undefined }) => {
	useEffect(() => {
		if (!productId) return;
		recordRecentlyViewed(productId);
	}, [productId]);

	return null;
};
